import { render, staticRenderFns } from "./UserSolid.vue?vue&type=template&id=9e85153a&"
import script from "./UserSolid.vue?vue&type=script&lang=ts&"
export * from "./UserSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports